import ExpertProfilePortfolioEditModalComponent from './expert-profile-portfolio-edit-modal.component'

const ExpertProfilePortfolioEditModalModule = angular.module('cdbl.expert-profile.expert-profile-portfolio-edit-modal', [

])
  .component('cdblExpertProfilePortfolioEditModal', ExpertProfilePortfolioEditModalComponent)
  .name

export default ExpertProfilePortfolioEditModalModule
